import LoginPage from './LoginPage'
import ForgotPasswordPage from './ForgotPasswordPage'

export default [
  {
    path: '/login',
    name: 'login',
    component: LoginPage,
    meta: {
      requireNoLogin: true,
      requireLogin: false,
      navigation: false
    }
  },
  {
    path: '/forgot-password/:token?',
    name: 'forgot-password',
    component: ForgotPasswordPage,
    meta: {
      requireNoLogin: true,
      requireLogin: false,
      navigation: false
    }
  }
]
